
(function () {
  "use strict";

  var PREVIEW_CLASS = "rc-apo-preview";

  function normalize(text) {
    return (text || "")
      .toLocaleLowerCase("tr-TR")
      .replace(/\s+/g, " ")
      .trim();
  }

  function optionLabel(option) {
    var label = option.querySelector(".mw-text--style-strong");
    return normalize(label ? label.textContent : "");
  }

  function allOptions() {
    return Array.prototype.slice.call(document.querySelectorAll(".mw-option"));
  }

  function findOptions(predicate) {
    return allOptions().filter(function (option) {
      return predicate(optionLabel(option), option);
    });
  }

  function isUsable(option) {
    var input;
    var style;

    if (!option || option.classList.contains("mw-hidden")) return false;

    input = option.querySelector("input.mw-option__control");
    if (!input || input.disabled) return false;

    style = window.getComputedStyle(option);
    return style.display !== "none" && style.visibility !== "hidden";
  }

  function findActiveTextOption(mode) {
    var options = findOptions(function (label, option) {
      if (!option.matches(".mw-option--type-text")) return false;

      if (mode === "stamp") {
        return label.indexOf("harf ekleyin") !== -1;
      }

      return (
        label.indexOf("kazıma yazısı") !== -1 ||
        label === "yazı ekleyin"
      );
    });

    for (var i = 0; i < options.length; i += 1) {
      if (isUsable(options[i])) return options[i];
    }

    return null;
  }

  function findFontOption() {
    var options = findOptions(function (label, option) {
      if (!option.matches(".mw-option--type-swatch")) return false;

      return (
        label === "font" ||
        label.slice(-5) === " font" ||
        label.indexOf("yazı tipi") !== -1
      );
    });

    for (var i = 0; i < options.length; i += 1) {
      if (isUsable(options[i])) return options[i];
    }

    return null;
  }

  function selectedStampFinish() {
    var options = findOptions(function (label, option) {
      return (
        option.matches(".mw-option--type-swatch") &&
        label.indexOf("baskı tipi") !== -1
      );
    });
    var option = null;
    var selected;
    var valueContainer;
    var image;
    var valueText;

    for (var i = 0; i < options.length; i += 1) {
      if (isUsable(options[i])) {
        option = options[i];
        break;
      }
    }

    if (!option) return "dark";

    selected = option.querySelector('input[type="radio"]:checked');
    if (!selected) return "dark";

    valueContainer = selected.closest(".mw-option__value");
    image = valueContainer ? valueContainer.querySelector("img") : null;
    valueText = normalize(
      (image ? image.getAttribute("alt") : "") +
        " " +
        (valueContainer ? valueContainer.textContent : "")
    );

    if (
      valueText.indexOf("altın") !== -1 ||
      valueText.indexOf("yaldız") !== -1
    ) {
      return "gold";
    }

    return "dark";
  }

  function selectedPersonalizationText() {
    var groups = findOptions(function (label, option) {
      if (!option.matches(".mw-option--type-button")) return false;

      return (
        label.indexOf("kişiselleştirme") !== -1 ||
        label.indexOf("harf işlemesi") !== -1
      );
    });

    var selections = [];

    groups.forEach(function (group) {
      var checked = group.querySelector('input[type="radio"]:checked');
      var valueContainer = checked
        ? checked.closest(".mw-option__value")
        : null;

      if (valueContainer) selections.push(valueContainer.textContent);
    });

    return normalize(selections.join(" "));
  }

  function detectMode() {
    var selection = selectedPersonalizationText();
    var stampOption = findActiveTextOption("stamp");
    var laserOption = findActiveTextOption("laser");

    if (
      stampOption &&
      (selection.indexOf("harf baskı") !== -1 ||
        selection.indexOf("baskı") !== -1)
    ) {
      return "stamp";
    }

    if (
      laserOption &&
      (selection.indexOf("lazer") !== -1 ||
        selection.indexOf("kazıma") !== -1)
    ) {
      return "laser";
    }

    if (stampOption && !laserOption) return "stamp";
    if (laserOption && !stampOption) return "laser";

    return null;
  }

  function isStrapProduct() {
    return (
      findOptions(function (label) {
        return label.indexOf("harf işlemesi") !== -1;
      }).length > 0 ||
      findOptions(function (label) {
        return label === "yazı tipi";
      }).length > 0
    );
  }

  function profileName(mode) {
    if (mode === "stamp") return "stamp";
    if (isStrapProduct()) return "laserStrap";
    return "laserWallet";
  }

  function selectedFont(fontOption) {
    var selected = fontOption
      ? fontOption.querySelector('input[type="radio"]:checked')
      : null;

    if (!selected) return "oswald";

    var valueContainer = selected.closest(".mw-option__value");
    var image = valueContainer ? valueContainer.querySelector("img") : null;
    var fontName = normalize(image ? image.getAttribute("alt") : "");

    if (fontName.indexOf("charm") !== -1) return "charm";
    if (fontName.indexOf("kauf") !== -1) return "kaufmann";
    return "oswald";
  }

  function createPreview() {
    var preview = document.createElement("div");
    preview.className = PREVIEW_CLASS;
    preview.innerHTML =
      '<div class="rc-apo-preview__canvas">' +
      '<span class="rc-apo-preview__text">Yazı</span>' +
      "</div>";
    return preview;
  }

  function ensurePreview(textOption, mode, profile) {
    var preview = document.querySelector("." + PREVIEW_CLASS);
    var nextClassName = PREVIEW_CLASS + " " + PREVIEW_CLASS + "--" + profile;

    if (!preview) preview = createPreview();
    if (preview.className !== nextClassName) preview.className = nextClassName;
    if (preview.getAttribute("data-mode") !== mode) {
      preview.setAttribute("data-mode", mode);
    }

    if (preview.previousElementSibling !== textOption) {
      textOption.insertAdjacentElement("afterend", preview);
    }

    return preview;
  }

  function removePreview() {
    var preview = document.querySelector("." + PREVIEW_CLASS);
    if (preview) preview.remove();
  }

  function updatePreview() {
    var mode = detectMode();
    var textOption;
    var textInput;
    var profile;
    var preview;
    var previewText;
    var enteredText;
    var font;
    var fontStyles;
    var style;

    if (!mode) {
      removePreview();
      return;
    }

    textOption = findActiveTextOption(mode);
    textInput = textOption
      ? textOption.querySelector('input.mw-option__control[type="text"]')
      : null;

    if (!textOption || !textInput) {
      removePreview();
      return;
    }

    profile = profileName(mode);
    preview = ensurePreview(textOption, mode, profile);
    previewText = preview.querySelector(".rc-apo-preview__text");
    enteredText = textInput.value.trim();
    previewText.textContent = enteredText || "Yazı";

    if (mode === "stamp") {
      preview.classList.add(
        selectedStampFinish() === "gold"
          ? "rc-apo-preview--stamp-gold"
          : "rc-apo-preview--stamp-dark"
      );
      previewText.style.fontFamily = '"Gill Sans", Arial, sans-serif';
      previewText.style.fontSize = "42px";
      return;
    }

    font = selectedFont(findFontOption());
    fontStyles = {
      oswald: {
        family: '"Oswald", sans-serif',
        size: profile === "laserStrap" ? "34px" : "32px",
      },
      charm: { family: '"Charm", cursive', size: "36px" },
      kaufmann: { family: '"Kaufmann", cursive', size: "40px" },
    };
    style = fontStyles[font] || fontStyles.oswald;
    previewText.style.fontFamily = style.family;
    previewText.style.fontSize = style.size;
  }

  var updateQueued = false;

  function queueUpdate() {
    if (updateQueued) return;
    updateQueued = true;

    window.requestAnimationFrame(function () {
      updateQueued = false;
      updatePreview();
    });
  }

  document.addEventListener("input", function (event) {
    if (event.target && event.target.matches(".mw-option__control")) {
      queueUpdate();
    }
  });

  document.addEventListener("change", function (event) {
    if (event.target && event.target.matches(".mw-option__control")) {
      queueUpdate();
    }
  });

  var observer = new MutationObserver(queueUpdate);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "disabled", "checked"],
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", queueUpdate, { once: true });
  } else {
    queueUpdate();
  }
})();